import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from "@ngx-translate/core";
import { PositiveNegativeRendererComponent } from './positive-negative-renderer.component';

@NgModule({
  declarations: [ PositiveNegativeRendererComponent ],
  exports: [ PositiveNegativeRendererComponent ],
  imports: [
    CommonModule
  ],
  providers: [
    TranslatePipe
  ]
})
export class PositiveNegativeRendererModule { }
